import * as reactMenu from '@szhsin/react-menu';
import styled from '../../styled';
import fromTheme from '../../fromTheme';
import { createElement as rc } from 'react';

const FocusableItem = styled(reactMenu.FocusableItem)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${fromTheme('menu', 'header', 'gap')};
`;

export default function MenuShellItem(props) {
    const { children } = props;
    // const child = Array.isArray(children) ? children[0] : children;
    return rc(FocusableItem, null, children);
}
